module.exports = __webpack_public_path__ + "img/chat-info-sp-arrow.2668bc3a.svg";